import Cookies from 'js-cookie'

// Click and browser ids the backend forwards to the TikTok Events API. The
// server cannot read either: the API lives on another origin, so neither the
// landing URL nor the site's cookies reach it.

const TTCLID_STORAGE_KEY = 'arena_ttclid'

/**
 * Remembers the TikTok click id from the landing URL (last click wins).
 *
 * The pixel keeps its own `ttclid` cookie, but it loads only after consent —
 * often a page later, when the id is gone from the URL. Left in the URL on
 * purpose, so a pixel that is already loaded still reads it.
 */
export const captureTtclidFromUrl = (searchParams: URLSearchParams): void => {
  const ttclid = searchParams.get('ttclid')?.trim()
  if (!ttclid) {
    return
  }

  try {
    localStorage.setItem(TTCLID_STORAGE_KEY, ttclid)
  } catch {}
}

const storedTtclid = (): string | undefined => {
  try {
    return localStorage.getItem(TTCLID_STORAGE_KEY)?.trim() || undefined
  } catch {
    return undefined
  }
}

/** `ttp` is the pixel's `_ttp` cookie, present once the pixel has loaded. */
export const tiktokAttributionPayload = (): {
  ttclid?: string
  ttp?: string
} => {
  const ttclid = storedTtclid() ?? Cookies.get('ttclid')
  const ttp = Cookies.get('_ttp')

  return {
    ...(ttclid ? { ttclid } : {}),
    ...(ttp ? { ttp } : {})
  }
}
